import { create } from 'zustand';

export type MessageRole = 'user' | 'ai';

export interface ChatMessage {
  id: string;
  role: MessageRole;
  content: string;
  timestamp: Date;
  isError?: boolean;
}

interface ChatStore {
  messages: ChatMessage[];
  isLoading: boolean;
  isHistoryLoading: boolean;
  userName: string;
  addMessage: (role: MessageRole, content: string, isError?: boolean) => void;
  setMessages: (messages: ChatMessage[]) => void;
  setLoading: (loading: boolean) => void;
  setHistoryLoading: (loading: boolean) => void;
  clearMessages: () => void;
}
const WELCOME_MESSAGE =
  'Hi! I am your Paymob AI assistant. I listen, understand what you need, and help you stay on top of your daily business and finances.';
const HISTORY_FAIL_MESSAGE: ChatMessage = {
  id: 'history-fail',
  role: 'ai',
  content: 'Sorry failed to load your chat history, ask me again.',
  timestamp: new Date(),
  isError: true,
};

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  isLoading: false,
  isHistoryLoading: true,
  userName: '',

  addMessage: (role, content, isError = false) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          id: `${Date.now()}-${Math.random()}`,
          role,
          content,
          timestamp: new Date(),
          isError,
        },
      ],
    })),

  setMessages: (messages) => set({ messages }),

  setLoading: (loading) => set({ isLoading: loading }),

  setHistoryLoading: (loading) => set({ isHistoryLoading: loading }),

  clearMessages: () => set({ messages: [HISTORY_FAIL_MESSAGE] }),
}));

export { WELCOME_MESSAGE, HISTORY_FAIL_MESSAGE };
